import React from 'react';
import { Switch, Card, Radio, RadioGroup, Space, Modal } from 'components';
import styled from 'styled-components';
import { AgentGroup } from '@bb/domain/dist/types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { OfferNoticiationProps } from '../types';

const OfferNotification: React.FC<OfferNoticiationProps> = ({
  handleChangeSettings,
  offerSettings,
}) => {
  const popConfirmModal = () => new Promise(resolve => {
      Modal.confirm({
        icon: <ExclamationCircleOutlined />,
        title: 'Are you sure you want to continue?',
        content: (
          <GreyText>
            This will change offer notification settings for all current and new
            users and listings in your brokerage. Please ensure agents within
            your brokerage are made aware of these changes after you save.
          </GreyText>
        ),
        okText: 'Continue',
        cancelText: 'Cancel',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

  const onChange = async (newOfferSettings: typeof offerSettings) => {
    const isConfirm = await popConfirmModal();
    if (!isConfirm) return;

    handleChangeSettings('offerSettings', newOfferSettings);
  };

  return (
    <Card
      type="primary"
      title="Offer Notification Settings"
      subtitle={
        <GreyText>
          This setting will determine who will be notified when an offer is
          registered (on an existing or new listing)
        </GreyText>
      }
      id="general"
    >
      <RadioGroup
        value={offerSettings.agentGroup}
        onChange={e =>
          onChange({
            ...offerSettings,
            agentGroup: e.target.value,
          })
        }
      >
        <Space direction="vertical">
          <Radio
            value={'all' as AgentGroup}
            data-cy="offerNotification-radio-all"
          >
            <Space direction="vertical">
              <RadioText>Auto Notify All Showing Agents</RadioText>
              <RadioSubText>
                All Showing agents will be instantly notified
              </RadioSubText>
            </Space>
          </Radio>
          <Radio
            value={'none' as AgentGroup}
            data-cy="offerNotification-radio-none"
          >
            <Space direction="vertical">
              <RadioText>Notify Listing Agents ONLY</RadioText>
              <RadioSubText>
                A notification wil be sent to the listing agent(s) only. They
                will decide when and whom to notify
              </RadioSubText>
            </Space>
          </Radio>
        </Space>
      </RadioGroup>
      <Gap16 />

      <Space direction="horizontal">
        <Switch
          data-cy="offerNotification-switch"
          checked={offerSettings.shouldShowOfferCount}
          onChange={checked =>
            onChange({
              ...offerSettings,
              shouldShowOfferCount: checked,
            })
          }
        />
        Include the total # of registered offers in showing confirmation (for
        existing and new listings)
      </Space>
    </Card>
  );
};

const GreyText = styled.span`
  color: #808080;
  display: block;
`;

const RadioText = styled.span``;
const RadioSubText = styled.span`
  color: #a0a0a0;
  font-size: 12px;
`;

const Gap16 = styled.div`
  height: 16px;
`;

export default OfferNotification;
